<div class="container" style="max-width: 800px; margin-left: 0">
  <div class="row" *ngFor="let rightInCat of rightsInCategory">
    <h1>{{rightInCat.Category}}</h1>
    <div class="col-12 mb-2">
      <div class="row">
        <div class="col-5"></div>
        <div class="col-7">
          <div style="display: inline-block; width: 150px; font-weight: bold;">Container rights</div>
          <div style="display: inline-block; width: 150px; font-weight: bold; margin-left: 40px;">Effective rights</div>
        </div>
      </div>
    </div>
    <div class="col-12 right" *ngFor="let right of rightInCat.Rights; let i = index">
      <div class="row">
        <div class="col-5" style="line-height: 50px">
          {{ right.Id | translate: right.Name }}
        </div>
        <div class="col-7">
          <span> 
            <mat-form-field appearance="outline" style="width: 150px">
              <mat-select [value]="right.ContainerRight" (selectionChange)="updateRightValue(right.Id, $event)">
                <mat-option [value]="1">
                  True
                </mat-option>
                <mat-option [value]="0">
                  False
                </mat-option>
                <mat-option [value]="2">
                  Not set
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <div style="vertical-align: top; display: inline-block; width: 150px; font-weight: bold; margin-left: 40px; line-height: 50px;">{{ right.EffectiveRight }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
